import { getAuthAPI } from './api'
import { SavedBrushedObject } from '@/types'
type UserSettingsType = {
  default_tag : string | null,
  brush_settings: object | null
}
type UserImagesType = string []

export const fetchDefaultSetting = async ():Promise<UserSettingsType>=> {
  const authApi = getAuthAPI();
  let res = {}
  try {
    const _res =  await authApi.get('/splash/settings')
    res = _res.data;
  } catch( e) {
    console.error( e )
  }
  return res as UserSettingsType;
}


export const getUserImages = async ():Promise<UserImagesType>=> {
  const authApi = getAuthAPI();
  let res = []
  try {
    const _res =  await authApi.get('/splash/user_images')
    res = _res.data.user_images;
  } catch( e) {
    console.error( e )
  }
  return res as UserImagesType;
}


export const saveBrushSetting = async ( brushSettings: SavedBrushedObject[]):Promise< SavedBrushedObject[] >=> {
  const authApi = getAuthAPI();
  const postData = {
    brush_settings: brushSettings
  };
  let res = []
  try {
    const _res =  await authApi.post('/splash/brush_settings', 
      postData,
        {
        'headers': {
          'Content-Type': 'application/json'
        } // Specify the content type as JSON
      })
    res = _res.data;
  } catch( e) {
    console.error( e )
  }
  return res as SavedBrushedObject[];
}